class AdRepositioner {
	/**
	 * Reposition ads in content on a certain breakpoint
	 *
	 * @param {string} id         The id of the ad that you want to move
	 * @param {Array}  elements   An array of element types (html tags) that you want the ad to skip
	 * @param {number} amount     The ammount of elements the ad should skip before being placed
	 * @param {number} breakpoint The repositioning will trigger on any screensize lower then the breakpoint
	 */
	reposition(id, elements, amount, breakpoint) {
		if (window.screen.width < breakpoint) {
			const article = document.getElementsByClassName('article-body')[0];
			if (typeof article === 'undefined') {
				return;
			}
			const nodes = article.childNodes;
			let nodeCount = 0;
			for (let i = 0; i < nodes.length; i++) {
				if (elements.includes(nodes[i].nodeName)) {
					nodeCount++;
					if (nodeCount === amount) {
						const ad = document.getElementById(id);
						article.insertBefore(ad, nodes[i].nextSibling);
					}
				}
			}
		}
	}

	/**
	 * Switch 2 ad position on a certain breakpoint
	 *
	 * @param {string} id1
	 * @param {string} id2
	 * @param {number} breakpoint
	 */
	switchAds(id1, id2, breakpoint) {
		if (window.screen.width < breakpoint) {
			const ad1 = jQuery('#' + id1);
			const location1 = ad1.prev();
			const ad2 = jQuery('#' + id2);
			const location2 = ad2.prev();

			ad1.insertAfter(location2);
			ad2.insertAfter(location1);
		}
	}
}

const instance = new AdRepositioner();
export default instance;
